import { combineReducers } from 'redux';

import artifactsReducer, { ArtifactsState } from './artifactsReducer';
import commonReducer, { commonStoreState } from './commonStore';
import generationReducer, { GenerationState } from './generationReducer';
import musicReducer, { musicStoreState } from './musicStore';

import sessionReducer, { SessionState } from './sessionReducer';
import twinReducer, { twinState } from './twinReducer';

const rootReducer = combineReducers({
  commonReducer,
  musicReducer,
  sessionReducer,
  artifactsReducer,
  generationReducer,
  twinReducer,
});

export default rootReducer;

export interface RootState {
  commonReducer: commonStoreState;
  musicReducer: musicStoreState;
  sessionReducer: SessionState;
  artifactsReducer: ArtifactsState;
  generationReducer: GenerationState;
  twinReducer: twinState;
}
